import React from 'react';
import doc1 from '../../assets/doctores/doc1.png';
import doc2 from '../../assets/doctores/doc2.png';
import doc3 from '../../assets/doctores/doc3.png';
import '../../features/medicos/styles/doctores.css';

const DoctoresAlDia = ({ onVerQuienesSomos }) => {
  return (
    <div className="doctores-wrapper" id="medicos">
      <h2 className="titulo-doctores">
        Médicos{' '}
        <span className="bold">
          al día
          <br />
        </span>
      </h2>

      <div className="imagenes-wrapper">
        <img
          src={doc1}
          alt="Médicos BioMercy"
          loading="lazy"
          className="imagen-pequena izquierda"
        />
        <img
          src={doc2}
          alt="Evento BioMercy"
          loading="lazy"
          className="imagen-grande"
        />
        <img
          src={doc3}
          alt="Stand BioMercy"
          loading="lazy"
          className="imagen-pequena derecha"
        />
      </div>

      <p className="subtitulo">
        <strong>
          Siempre <span className="rosa-doctor">presentes</span>
        </strong>
      </p>
      <p className="descripcion-doctor">
        Ofrecemos medicamentos que cumplen con los más altos estándares de{' '}
        <br />
        <strong>calidad, seguridad y eficacia.</strong>
      </p>

      <button className="boton-info" onClick={onVerQuienesSomos}>
        Más información
      </button>
    </div>
  );
};

export default DoctoresAlDia;
